<template>
  <div class="page-main">
    <div class="vertify-title">个人认证</div>
    <div class="vertify-li spaceLeft">
      <div class="vertify-li-title">用户名称</div>
      <div class="width-auto">
        {{ this.utils.xxShow("name", this.sessionData.loginName) }}
      </div>
    </div>
    <div class="vertify-li spaceLeft">
      <div class="vertify-li-title">手机号码</div>
      <div class="width-auto">{{ this.sessionData.mobile }}</div>
      <div></div>
    </div>
    <div class="vertify-li spaceLeft">
      <div class="vertify-li-title">用户状态</div>
      <div class="width-auto">{{ statusArr[userObj.status].text }}</div>
      <div>
        <a-button type="link" v-if="userObj.status == 2 || userObj.status == 1" @click="toPage('info')">查看详情</a-button>
        <a-button type="link" v-if="userObj.status == 0"  @click="toPage('edit')">去认证</a-button>
        <a-button type="link" v-if="userObj.status == 3"  @click="toPage('edit')">修改</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      statusArr: [
        {
          text: "已注册",
          value: "0",
        },
        {
          text: "待认证",
          value: "1",
        },
        {
          text: "已认证",
          value: "2",
        },
        {
          text: "已拒绝",
          value: "3",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      sessionData: "home/getSessionData",
      userObj: "home/getUserObj",
    }),
  },
  methods: {
    toPage(mode) {
      this.$router.push(`/security/editPersonalInfo?mode=${mode}`);
    },
  },
  created() {
    
  },
  mounted() {},
  watch: {},
};
</script>
<style scoped>
.vertify-title {
  font-size: 14px;
  color: #667380;
  line-height: 20px;
  font-family: Lucida Grande, Lucida Sans Unicode, Hiragino Sans GB, WenQuanYi Micro Hei,
    Verdana, Aril, sans-sefi, 微软雅黑;
  letter-spacing: 0;
  margin: 15px 0;
}
.vertify-li-title {
  color: #0d253e;
  font-weight: bold;
  max-width: 300px;
  width: 30%;
}
.vertify-li {
  min-height: 75px;
  padding-left: 15px;
}
.vertify-li a {
  margin: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/security/personalAuthentication/index.vue